import React, { useEffect, useState } from "react";
import { Box, Text, VStack } from "@chakra-ui/react";
import { Cartographic, Math as CesiumMath } from "cesium";
import { computeZoomLevel } from "../utilies/MapUtility";
import { useAppStore } from "../context/store";

function CameraInfo() {
  const showCameraInfo = useAppStore((s) => s.showCameraInfo);
  const viewerRef = useAppStore.getState().viewerRef;

  const [height, setHeight] = useState("-");
  const [verticalAngle, setVerticalAngle] = useState("-");
  const [horizontalAngle, setHorizontalAngle] = useState("-");
  const [zoom, setZoom] = useState("-");

  useEffect(() => {
    let rafId = null;
    let viewer = null;
    let updateInfo = null;

    const init = () => {
      if (!viewerRef?.current) {
        rafId = requestAnimationFrame(init);
        return;
      }

      viewer = viewerRef.current;
      const camera = viewer.camera;

      updateInfo = () => {
        const pos = Cartographic.fromCartesian(camera.position);
        setHeight(pos.height.toFixed(2));
        setVerticalAngle(CesiumMath.toDegrees(camera.pitch).toFixed(1));
        setHorizontalAngle(CesiumMath.toDegrees(camera.heading).toFixed(1));

        const z = computeZoomLevel(viewer);
        setZoom(z.toFixed(2));
      };

      viewer.scene.postRender.addEventListener(updateInfo);
    };

    init();

    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      if (viewer && updateInfo) {
        try {
          viewer.scene.postRender.removeEventListener(updateInfo);
        } catch {}
      }
    };
  }, [viewerRef]);

  if (!showCameraInfo) return null;

  return (
    <Box position="absolute" bg="white" bottom="100px" right="20px" p={2} borderRadius="lg" shadow="md">
      <Text fontSize="16px">Camera Pose</Text>
      <VStack gap={0} align="start">
        <Text fontSize="14px">Height: {height} m</Text>
        <Text fontSize="14px">Vertical Angle: {verticalAngle}°</Text>
        <Text fontSize="14px">Horizontal Angle: {horizontalAngle}°</Text>
        <Text fontSize="14px">Zoom Level: {zoom}</Text>
      </VStack>
    </Box>
  );
}

export default CameraInfo;
